module.exports = __webpack_public_path__ + "img/fzds2.882939f1.png";